/**
 * @file   src\mobile\pages\HandleMessagesScreens.js
 * @brief  This file is responsible for handling message section in mobile view
 * @date   Jan, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import "../../styles/clients.scss";
import { getUserId, loggedInUser } from "../../../helpers/common";
import { useDispatch, useSelector } from "react-redux";
import { loginOrSignUp } from "../../../helpers/message";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { MESSAGES_VIEW } from "../../../constants/onBoarding";
import DirectMessagesWrapper from "../../../mobile/components/Messages/v2/DirectMessagesWrapper";
import { getDirectChats } from "../../../services/messagesService";
import DirectMessagesRightSection from "../../../components/Messages/DirectMessagesRightSection";
import { getUserProfileForDM } from "../../../services/v2/agentProfile";
import { pageURLs } from "../../../constants/v2/pageURLs";

const HandleDirectMessagesScreens = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [uiKey, setUIKey] = useState(null);
  const userId = getUserId();
  const userDetails = loggedInUser();

  const [searchParams, setSearchParams] = useSearchParams();
  const selectedId = searchParams.get("id");
  const [directChats, setDirectChats] = useState([]);
  const [agentProfile, setAgentProfile] = useState(null);
  const params = new URLSearchParams(location.search);
  const chatId = params.get("id");

  //GET SELECTED AGENT DETAILS
  const getAgentDetails = async (slug) => {
    await getUserProfileForDM(slug)
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          setAgentProfile(responseResult);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        navigate(pageURLs.mobileDirectMessages)
        console.log("Error", err);
      });
  };

  useEffect(() => {
    if (chatId) {
      getAgentDetails(chatId);
    }
  }, [location.search, getUserProfileForDM]);

  useEffect(() => {
    if (selectedId) {
      setUIKey(MESSAGES_VIEW);
    }
  }, [selectedId]);

  useEffect(() => {
    let email = _.get(userDetails, "userInfo.email", null);
    let login = loginOrSignUp(email);

    if (!login) {
      navigate(pageURLs.mobileHome);
    }
  }, []);

  useEffect(() => {
    getDirectChatsLeft();
  }, [chatId]);

  const getDirectChatsLeft = async () => {
    await getDirectChats()
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        setDirectChats(responseResult);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const updateLastMessage = (chatId, lastMessage) => {
    const chat = directChats.find((item) => item.id === chatId);
    if (chat) {
      chat.lastMessage = lastMessage;
      chat.lastMessageAt = new Date().getTime();
      setDirectChats([...directChats]);
    }
  };

  /**
   * To handle message section ui
   * @returns
   */
  const handleMessagesdUI = () => {
    switch (uiKey) {
      case MESSAGES_VIEW:
        return (
          <DirectMessagesRightSection
            setUIKey={setUIKey}
            updateLastMessage={updateLastMessage}
            userId={userId}
            agentProfile={agentProfile}
            isFromMobile={true}
          />
        );

      default:
        return (
          <DirectMessagesWrapper
            setUIKey={setUIKey}
            userId={userId}
            messages={directChats}
          />
        );
    }
  };

  return <>{handleMessagesdUI()}</>;
};

export default HandleDirectMessagesScreens;
